import { Box, styled } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(4, 4),
}));
